/* eslint-disable no-use-before-define */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types,react/jsx-no-target-blank,no-nested-ternary */
import React, { useState } from 'react';
import get from 'lodash/get';
import T from 'i18n-react';
import { Box, Button, Checkbox, InputAdornment, SvgIcon, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Visibility } from '@material-ui/icons';
import loginStyles from 'assets/jss/icw/loginStyle';
import { TextField } from 'icw-components/InputFields';
import viewOff from 'assets/img/view-off.png';
import checkGreen from 'assets/img/check_green.png';
import checkGrey from 'assets/img/check_grey.png';
import checkCircle from 'assets/img/check_circle.png';
import errorCircle from 'assets/img/error_circle.png';
import LinkedInButton from 'icw-components/LinkedInButton';
import { LINKEDIN_PATHNAME_TYPES } from 'shared/constants';
import { isProductionEnv } from 'util/icwUtility';

import CardMetaUser from 'views/Login/components/CardMetaUser';
import Description from 'views/Login/components/Description';
import { AUTH_TYPES } from './const';

const RegistrationForm = (props) => {
  const {
    // locale,
    classes,
    values,
    showPassword,
    touched,
    errors,
    handleChange,
    handleBlur,
    handleTogglePassword,
    handleSubmit,
    updateState,
    invitation,
    // setFieldTouched,
  } = props;
  // const isValid = values.email && values.password;
  const format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

  const [showStatusError, setShowStatusError] = useState(false);
  const [passwordHint, setPasswordHint] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const checkPasswordValidated = (type, value) => {
    let isValidated = false;

    switch (type) {
      case 'length':
        if (value.length < 8) isValidated = true;
        break;

      case 'uppercaseCharacter':
        if (!/[A-Z]/.test(value)) isValidated = true;
        break;

      case 'lowercaseCharacter':
        if (!/[a-z]/.test(value)) isValidated = true;
        break;

      case 'symbol':
        if (!format.test(value)) isValidated = true;
        break;

      default:
        break;
    }

    return isValidated;
  };

  const onSubmitLinkedInRegistration = (linkedinInfo) => {
    const socialUserId = get(linkedinInfo, 'id');
    const email = get(linkedinInfo, 'email');

    updateState('values', 'email', email);

    handleSubmit({
      companyName: email,
      authType: AUTH_TYPES.social,
      socialUserId,
      email,
    });
  };

  const validateFinalPassword = (password) =>
    checkPasswordValidated('password', password) ||
    checkPasswordValidated('uppercaseCharacter', password) ||
    checkPasswordValidated('lowercaseCharacter', password);

  const onSubmitSimpleRegistration = (e) => {
    const { email, companyName, agreeTerm, password } = errors;

    e.preventDefault();
    setIsSubmitting(true);
    setPasswordHint(false);

    const validSubmit = companyName && email && agreeTerm && password;

    if (validateFinalPassword(values.password) && !validSubmit) {
      setShowStatusError(true);
    } else {
      handleSubmit(
        { authType: invitation.from === 'invitation' ? AUTH_TYPES.invitation : AUTH_TYPES.simple },
        e
      );
      setShowStatusError(false);

      // DO TRACKING WITH WORDPRESS
      if (isProductionEnv()) {
        handleWordPressActiveCampaignTrack(values);
      }
    }
  };

  const handleWordPressActiveCampaignTrack = ({ email, password }) => {
    const activeCampaignRegisterTrackURL = 'https://icwmarketing.activehosted.com/proc.php/f/7';
    const formData = new FormData();
    formData.append('u', 7);
    formData.append('f', 7);
    formData.append('s', '');
    formData.append('c', 0);
    formData.append('m', 0);
    formData.append('act', 'sub');
    formData.append('v', '2');
    formData.append('or', '0bf5aa65006ae75e0259aee0969ae4f5');
    formData.append('email', email);
    formData.append('field[3]', password);
    formData.append('jsonp', true);
    fetch(activeCampaignRegisterTrackURL, {
      method: 'POST',
      body: formData,
      mode: 'no-cors',
    })
      .then((res) => res.json())
      .then((result) => {})
      .catch((error) => {});
  };

  return (
    <form onSubmit={onSubmitSimpleRegistration} className={classes.loginContainer}>
      <h3 className={classes.title}>
        {invitation.from === 'invitation'
          ? 'Accept Buyer Invitation'
          : T.translate('registration.createAccount.title')}
      </h3>
      {invitation.from !== 'invitation' && (
        <>
          <LinkedInButton
            pathname={LINKEDIN_PATHNAME_TYPES.registration}
            title={T.translate('registration.createAccount.linkedIn')}
            onSuccess={onSubmitLinkedInRegistration}
          />
          <Typography className={classes.orTitle}>{T.translate('login.orTitle')}</Typography>
        </>
      )}

      {invitation.from !== 'invitation' ? (
        <>
          <div>
            <TextField
              autoFocus
              fullWidth
              margin="dense"
              label={T.translate(`registration.createAccount.companyName`)}
              name="companyName"
              value={values.companyName}
              error={isSubmitting && touched.companyName && !!errors.companyName}
              helperText={
                isSubmitting && touched.companyName && errors.companyName && errors.companyName
              }
              onChange={handleChange}
              onBlur={handleBlur}
              style={{ paddingTop: '10px' }}
              className={classes.textFieldCustom}
            />
          </div>
          <div>
            <TextField
              fullWidth
              margin="dense"
              label={T.translate(`registration.createAccount.email`)}
              name="email"
              value={values.email}
              error={isSubmitting && touched.email && !!errors.email}
              helperText={isSubmitting && touched.email && errors.email && errors.email}
              onChange={handleChange}
              onBlur={handleBlur}
              style={{ paddingTop: '10px' }}
              className={classes.textFieldCustom}
            />
          </div>
        </>
      ) : (
        <>
          <Description>
            Please enter password to begin co-operating with <b>{invitation.companyName}</b>
          </Description>
          <CardMetaUser email={invitation.email} />
        </>
      )}

      <div>
        <TextField
          fullWidth
          margin="normal"
          label={T.translate(`registration.createAccount.password`)}
          type={showPassword ? 'text' : 'password'}
          name="password"
          value={values.password}
          onBlur={(e) => {
            setPasswordHint(true);
            handleBlur(e);
          }}
          onFocus={() => {
            setPasswordHint(true);
          }}
          error={isSubmitting && touched.password && !!validateFinalPassword(values.password)}
          helperText={
            !!validateFinalPassword(values.password) &&
            isSubmitting &&
            (touched.password
              ? passwordHint
                ? showStatusError
                  ? T.translate('registration.errors.errorPassword')
                  : T.translate('registration.errors.invalidPasswordFormat')
                : null
                ? errors.password
                  ? errors.password
                  : null
                : showStatusError
                ? T.translate('registration.errors.invalidPasswordFormat')
                : T.translate('registration.errors.errorPassword')
              : null)
          }
          onChange={handleChange}
          style={{ paddingTop: '10px' }}
          className={classes.textFieldCustom}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {values.password && touched.password && !validateFinalPassword(values.password) && (
                  <img src={checkCircle} alt="checkIcon" />
                )}
                {showStatusError &&
                  values.password &&
                  touched.password &&
                  !!validateFinalPassword(values.password) && (
                    <img src={errorCircle} alt="checkIcon" />
                  )}
                {showPassword ? (
                  <SvgIcon
                    aria-label="Toggle password visibility"
                    onClick={handleTogglePassword}
                    style={{ marginLeft: 16 }}>
                    <Visibility />
                  </SvgIcon>
                ) : (
                  <img
                    src={viewOff}
                    width={24}
                    height={24}
                    alt="viewOff"
                    onClick={handleTogglePassword}
                    style={{ marginLeft: 16, marginBottom: 5 }}
                  />
                )}
              </InputAdornment>
            ),
          }}
        />
      </div>
      {isSubmitting && touched.password && passwordHint && (
        <Box display="flex" flexDirection="column">
          <Box display="flex" alignItems="center">
            <img
              src={checkPasswordValidated('length', values.password) ? checkGrey : checkGreen}
              alt="check"
            />
            <Typography
              style={{
                marginLeft: '10px',
                color: checkPasswordValidated('length', values.password) ? '#AAAAAA' : '#000000',
                fontSize: '12px',
                fontFamily: 'Roboto',
                marginBottom: '7x',
              }}>
              {T.translate('registration.errors.8digits')}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center">
            <img
              src={
                checkPasswordValidated('uppercaseCharacter', values.password)
                  ? checkGrey
                  : checkGreen
              }
              alt="checkGreen"
            />
            <Typography
              style={{
                marginLeft: '10px',
                color: checkPasswordValidated('uppercaseCharacter', values.password)
                  ? '#AAAAAA'
                  : '#000000',
                fontSize: '12px',
                fontFamily: 'Roboto',
                marginBottom: '7x',
              }}>
              {T.translate('registration.errors.uppercaseCharacter')}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center">
            <img
              src={
                checkPasswordValidated('lowercaseCharacter', values.password)
                  ? checkGrey
                  : checkGreen
              }
              alt="checkGreen"
            />
            <Typography
              style={{
                marginLeft: '10px',
                color: checkPasswordValidated('lowercaseCharacter', values.password)
                  ? '#AAAAAA'
                  : '#000000',
                fontSize: '12px',
                fontFamily: 'Roboto',
                marginBottom: '7x',
              }}>
              {T.translate('registration.errors.lowercaseCharacter')}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" mb="12px">
            <img
              src={checkPasswordValidated('symbol', values.password) ? checkGrey : checkGreen}
              alt="checkGreen"
            />
            <Typography
              style={{
                marginLeft: '10px',
                color: checkPasswordValidated('symbol', values.password) ? '#AAAAAA' : '#000000',
                fontSize: '12px',
                fontFamily: 'Roboto',
                marginBottom: '7x',
              }}>
              {T.translate('registration.errors.symbol')}
            </Typography>
          </Box>
        </Box>
      )}
      <Box
        display="flex"
        sx={{
          alignItems: {
            xs: 'flex-start',
            md: 'center',
          },
          marginTop: {
            xs: '30px',
            md: 0,
          },
        }}>
        <Checkbox
          classes={{ root: classes.checkbox }}
          name="agreeTerm"
          onChange={(e) => {
            const { name, checked } = e.target;
            handleChange({
              target: {
                name,
                value: checked,
              },
            });
          }}
          checked={values.agreeTerm}
          error={touched.agreeTerm && !!errors.agreeTerm}
          helperText={touched.agreeTerm && errors.agreeTerm}
        />
        <Box
          display="flex"
          fontSize="13px"
          fontWeight="400"
          mx={1}
          color="##232B3A"
          flexWrap="wrap">
          {T.translate('login.agreement.agree')}&nbsp;
          <a className={classes.alink} target="_blank" href="https://icw.io/terms-conditions/">
            {T.translate('login.agreement.term&Conditions')}
          </a>
          ,&nbsp;
          <a className={classes.alink} target="_blank" href="https://icw.io/privacy-policy/">
            {T.translate('login.agreement.privacyPolicy')}
          </a>
          ,&nbsp;
          <span
            style={{
              textTransform: 'lowercase',
            }}>
            {T.translate('login.agreement.and')}
          </span>{' '}
          &nbsp;
          <a className={classes.alink} target="_blank" href="https://icw.io/cookie-policy/">
            {T.translate('login.agreement.cookiesPolicy')}
          </a>
          .
        </Box>
      </Box>
      <div className={classes.btnBlock}>
        <Button type="submit" fullWidth color="primary" className={classes.button}>
          {T.translate('login.signUp')}
        </Button>
      </div>
    </form>
  );
};

export default withStyles(loginStyles)(RegistrationForm);
